/**
 * Static variables of all UI action ids.
 * This variables can be used in xml as UiAction="{id}".
 * @class UserAction
 */
export class UserAction {
    // sound
    static ActionToggleSound: string = "TOGGLE_SOUND";

    // exit
    static ActionExit: string = "EXIT";

    // paytable
    static ActionTogglePaytable: string = "TOGGLE_PAYTABLE";
    static ActionPaytableOn: string = "PAYTABLE_ON";
    static ActionPaytableOff: string = "PAYTABLE_OFF";

    // menu
    static ActionMenuOn: string = "MENU_ON";
    static ActionMenuOff: string = "MENU_OFF";
    static ActionToggleMenu: string = "TOGGLE_MENU";
    static ActionToggleMenuBack: string = "TOGGLE_MENU_BACK";
    static ActionSwitchControls: string = "SWITCH_CONTROLS";

    // help
    static ActionHelpOn: string = "HELP_ON";
    static ActionHelpOff: string = "HELP_OFF";
    static ActionHelpTerminal: string = "TERMINAL_HELP_CYCLE";

    // bet
    static ActionToggleBet: string = "TOGGLE_BET";

    // settings
    static ActionSettingsOn: string = "SETTINGS_ON";
    static ActionSettingsOff: string = "SETTINGS_OFF";

    // quickspin
    static ActionQuickspinDialogOff: string = "QUICKSPIN_DIALOG_OFF";
    static ActionQuickspinToggle: string = "QUICKSPIN_TOGGLE";

    //vibration
    static ActionVibrationToggle: string = "VIBRATION_TOGGLE";

    static ActionGameRoundReport: string = "GAME_ROUND_REPORT";
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/HTMLComponents/UserAction.ts
 **/